#import "../../../common/graphql/DocumentFileDistributionsByDocumentFileId.graphql"
query PersonalDocuments(
  $first: Int
  $after: Cursor
  $filter: EntityDocumentFilter
  $orderBy: [EntityDocumentsOrderBy!]
) {
  entityDocumentPersonalPools(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      id
      _isProtected
      _fileViewer
      _isDocumentTextExtensionExists
       _documentTextExtension {
          extendedDescription
          isImageDescriptionExists
          isTranslatedDescriptionExists
          sourceLanguage
          translatedDescription
          alternateDescription
          isAlternateDescriptionExists
        }
      fileIndexInformation
      indexName
      indexDescription
      indexReferenceNumber
      indexTransactionDate
      indexCurrencyId
      entityDocumentTypeId
      entityId
      comment
      fileReference
      iconType
      isShareable
      _isAccountingDocument
      _isReportingDocument
      _uploadDate
      _sharedByUser
      _isUpdatable
      _isDeletable
      _rowTimestamp
      _fileName
      _fileType
      _createdDate
      _isDocumentShare
      _documentContents
      _isDocumentTypeUpdatable
      indexAmount
      lookupName {
        lookupName
        id
        isApprovedVendor
        lookupCode
        lookupName
        lookupName2
        address1
        address2
        city
        state
        zipCode
        country
        phone
        emailAccount
      }
      ...DocumentFileDistributionsByDocumentFileId
      currency {
        isoCode
      }
      documentAppliedAmounts {
        id
        appliedTotal
        overageTotal
        retiredTotal
        usedTotal
        remainingTotal
        _isRemainingAmountAvailable
        _isRetiringBalanceAllowed
      }
      documentTypes {
        id
        documentType
        isAccountingDocument
        isSigningRequired
        _isAppliableDocumentType
        _isPoSystemDocument
      }
      extractionTypeId
      extractionType {
        isExtractProtected
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
